import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "text-subtitle-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "mr-4" }, null, -1)

import LawFirmBotGrid from '@/components/LawFirmBotGrid.vue';
	import FormCombobox from '@/components/FormCombobox.vue';

	import { defineComponent, nextTick, ref, Ref } from 'vue';
	import { VForm } from 'vuetify/components'
	import { LawFirm } from "@/interfaces/LawFirm";
	import LawFirmBotForm from "@/components/LawFirmBotForm.vue";
	import DeleteConfirmationForm from '@/components/DeleteConfirmationForm.vue'
	import { ApplicationService } from "@/services/ApplicationService";
	import { FormatterService } from "@/services/FormatterService";
	import { FormService } from "@/services/FormService";
	import { BotType } from '@/interfaces/BotType';
	import { IServerData, PageResult } from '@/interfaces/Search';
	import { Alert, AlertType } from '@/interfaces/Notification';
	import { IEntity } from '@/interfaces/Data';
	import { GlobalAlertService } from '@/services/GlobalAlertService';
	import { ApiResponse } from '@/interfaces/ApiResponse';
	import { LawFirmBot } from '@/interfaces/LawFirmBot';
	import { BaseService } from '@/services/BaseService';
	import { VersionsStore } from '@/Stores/VersionStore';

	interface Data extends IServerData {
		progress: number,
		saveProgress: boolean,
		firm: null | LawFirm,
		refAreas: Ref<[]>,
		refNewItem: Ref<LawFirmBot>,
		refBotTypes: Ref<BotType[]>,
		rulesName: Array<(value: string) => {}>,
		rulesCompanyId: Array<(value: string) => {}>,
	}

	const __default__ = defineComponent({
		props: {
			propId: {
				type: String,
				default: '0'
			},
		},
		data(): Data {
			return {
				progress: 0,
				saveProgress: false,
				firm: {
					id: parseInt(this.propId),
					name: '',
					instabotCompanyId: null,
					createDate: null,
					updateDate: null,
					apiKey: null,
					apiMasterKey: null,
					zipCodes: null,
					areasOfLaw: null,
				},
				refAreas: ref([]),
				refNewItem: ref(this.getDefaultLawFirm()),
				refBotTypes: ref([]),
				rulesName: [
					value => {
						if (value) return true;

						return 'Name cannot be empty.'
					},
				],
				rulesCompanyId: [
					value => {
						if (!value || /^\d+$/.test(value)) return true;

						return 'Instabot Company Id must consist at least 1 digits.'
					},
				],
				controller: 'lawfirm'
			}
		},
		created() {
			this.initialize();
		},
		watch: {
		},
		methods: {
			initialize() {
				this.loadFirm();
				this.loadBotTypes();
			},
			loadFirm() {
				const id = this.firm?.id;
				if (id) {
					this.progress++;
					ApplicationService
						.getEntity(id, this.controller, this.onError)
						.then(json => {
							const response = json as ApiResponse<LawFirm>;
							if (response.errorMessage) {
								throw response;
							}
							this.firm = response.data;
						})
						.finally(() => {
							this.progress--;
						});
				}
			},
			loadBotTypes() {
				const controller = 'bottype';
				const itemsPerPage = 100;
				const storeKey = `combobox-${itemsPerPage}`;
				this.progress++;
				ApplicationService
					.getEntities({ page: 1, itemsPerPage: itemsPerPage }, controller, new AbortController(), this.onError, storeKey)
					.then(json => {
						const response = json as ApiResponse<PageResult<BotType>>;
						if (response.errorMessage) {
							throw response;
						}
						VersionsStore.putData(controller, storeKey, json);
						this.refBotTypes = response.data?.entities || [];
					})
					.catch(reason => BaseService.processError(reason, this.onError))
					.finally(() => {
						this.progress--;
					});
			},
			getFormatter() {
				return FormatterService;
			},
			updateAlert(alertType?: AlertType, message?: string) {
				GlobalAlertService.showAlert(alertType ? { type: alertType, message: message } as Alert : null);
			},
			trySave() {
				FormService.processIfValid(this.$refs.form as VForm, this.save, this.onError);
			},

			save() {
				this.updateAlert();
				this.saveProgress = true;
				ApplicationService.updateEntity(this.firm as IEntity, this.controller, this.onError)
					.then((json) => {
						const id = this.firm?.id;
						const response = json as ApiResponse<LawFirm>;
						if (response.errorMessage) {
							throw response;
						}
						VersionsStore.increment(this.controller);
						this.firm = response.data || this.firm;
						this.$router.push(`/firms/${this.firm?.id}`);
						setTimeout(() => {
							GlobalAlertService.showAlert({ type: AlertType.success, message: `Law firm was successfully ${id ? 'updated' : 'created.'}` });
						}, 0);
					})
					.catch(reason => BaseService.processError(reason, this.onError))
					.finally(() => {
						this.saveProgress = false;
					});
			},

			onError(error: string) {
				this.updateAlert(AlertType.error, error);
			},

			getDefaultLawFirm(): LawFirmBot {
				return {
					id: 0,
					lawFirmId: this.firm?.id || 0,
					createDate: null,
					updateDate: null,
					botId: null,
					botTypeId: null,
					areaOfLawId: null,
					area: null,
					botType: null
				};
			},

			isReadonly() {
				return this.progress || this.saveProgress;
			},
		}
	});



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FirmView',
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createElementVNode("h2", null, _toDisplayString(_ctx.firm.id > 0 ? 'Edit Firm' : 'New firm'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "text-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "indigo-darken-3",
              variant: "flat",
              disabled: _ctx.isReadonly(),
              onClick: _ctx.trySave
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Save ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_v_progress_linear, { indeterminate: "" }, null, 512), [
      [_vShow, _ctx.isReadonly()]
    ]),
    _createVNode(_unref(VForm), {
      ref: "form",
      disabled: _ctx.isReadonly()
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.firm.createDate ? 'Created: ' + (_ctx.getFormatter().defaultDate())(_ctx.firm.createDate) : '') + " ", 1),
                    _hoisted_2,
                    _createTextVNode(" " + _toDisplayString(_ctx.firm.updateDate ? 'Updated: ' + (_ctx.getFormatter().defaultDate())(_ctx.firm.updateDate) : ''), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  "hide-details": "",
                  variant: "outlined",
                  modelValue: _ctx.firm.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firm.name) = $event)),
                  label: "Name",
                  rules: _ctx.rulesName
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  "hide-details": "",
                  variant: "outlined",
                  modelValue: _ctx.firm.instabotCompanyId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.firm.instabotCompanyId) = $event)),
                  label: "Instabot Company ID",
                  rules: _ctx.rulesCompanyId
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  "hide-details": "",
                  variant: "outlined",
                  modelValue: _ctx.firm.apiKey,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firm.apiKey) = $event)),
                  label: "ApiKey"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  "hide-details": "",
                  variant: "outlined",
                  modelValue: _ctx.firm.apiMasterKey,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.firm.apiMasterKey) = $event)),
                  label: "Master ApiKey"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(FormCombobox, {
                  propItems: _ctx.refAreas,
                  "onUpdate:propItems": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.refAreas) = $event)),
                  propSelectedItems: _ctx.firm.areasOfLaw,
                  "onUpdate:propSelectedItems": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.firm.areasOfLaw) = $event)),
                  propDisplayName: 'name',
                  propController: 'areaoflaw',
                  propTitle: 'Areas of law',
                  propDisabled: _ctx.isReadonly()
                }, null, 8, ["propItems", "propSelectedItems", "propDisabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(FormCombobox, {
                  propSelectedItems: _ctx.firm.zipCodes,
                  "onUpdate:propSelectedItems": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.firm.zipCodes) = $event)),
                  propDisplayName: 'code',
                  propController: 'zipcode',
                  propTitle: 'Zip codes',
                  propUseServerSearch: true,
                  propDisabled: _ctx.isReadonly()
                }, null, 8, ["propSelectedItems", "propDisabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.firm.id)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "text-right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "indigo-darken-3",
                        variant: "flat",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.refNewItem = _ctx.getDefaultLawFirm()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Add bot ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(LawFirmBotGrid, {
                        propAddItem: _ctx.refNewItem,
                        "onUpdate:propAddItem": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.refNewItem) = $event)),
                        propMultiple: false,
                        propId: _ctx.propId,
                        propEditForm: LawFirmBotForm,
                        propDeleteForm: DeleteConfirmationForm,
                        propBotTypes: _ctx.refBotTypes,
                        "onUpdate:propBotTypes": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.refBotTypes) = $event)),
                        propAreas: _ctx.refAreas,
                        "onUpdate:propAreas": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.refAreas) = $event))
                      }, null, 8, ["propAddItem", "propId", "propBotTypes", "propAreas"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 64))
}
}

})